import React from 'react';
import { ArrowRight, CalendarX2, CheckCircle2, FileWarning, MessagesSquare, ReceiptText } from 'lucide-react';
import { Link } from 'react-router-dom';

const PROBLEMS = [
  [CalendarX2, 'Calendari e prenotazioni sparsi tra canali diversi'],
  [FileWarning, 'Dati ospiti e adempimenti ricopiati a mano'],
  [ReceiptText, 'Rendiconti proprietari costruiti ogni volta da zero'],
  [MessagesSquare, 'Messaggi agli ospiti inviati uno per uno'],
];

const SOLUTIONS = [
  'Un solo calendario operativo per tutte le prenotazioni',
  'Flussi guidati per Alloggiati Web, ISTAT e tassa di soggiorno',
  'Report chiari e pronti per ogni proprietario',
  'Comunicazioni programmate prima, durante e dopo il soggiorno',
];

export const HomeSmartProblemSolution = ({ registrationPath = '/home-smart/registrazione' }) => (
  <section id="perche" className="scroll-mt-24 bg-[#f7faff] py-20 sm:py-28" data-testid="comparison-section">
    <div className="mx-auto max-w-6xl px-5 lg:px-8">
      <div className="max-w-3xl">
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#a17e12]" data-testid="comparison-eyebrow">Il lavoro cambia quando tutto parla</p>
        <h2 className="mt-4 text-3xl font-extrabold leading-tight text-[#08234c] sm:text-4xl" style={{ fontFamily: 'Georgia, serif' }} data-testid="comparison-title">Non serve un altro strumento.<br />Serve un unico modo di lavorare.</h2>
      </div>
      <div className="mt-12 grid gap-5 lg:grid-cols-2">
        <div className="rounded-lg border border-[#f1c5c0] bg-[#fff8f7] p-6 sm:p-8" data-testid="without-home-smart-panel">
          <p className="text-sm font-extrabold uppercase tracking-[0.18em] text-[#a33a32]">Senza Home Smart</p>
          <div className="mt-7 space-y-5">{PROBLEMS.map(([Icon, text], index) => <div key={text} className="flex items-start gap-4" data-testid={`problem-item-${index + 1}`}><Icon className="mt-0.5 h-5 w-5 shrink-0 text-[#b8473e]" /><p className="text-sm font-semibold leading-6 text-[#654847]">{text}</p></div>)}</div>
        </div>
        <div className="rounded-lg border border-[#bfdccf] bg-[#f4fbf7] p-6 sm:p-8" data-testid="with-home-smart-panel">
          <p className="text-sm font-extrabold uppercase tracking-[0.18em] text-[#1f7150]">Con Home Smart</p>
          <div className="mt-7 space-y-5">{SOLUTIONS.map((text, index) => <div key={text} className="flex items-start gap-4" data-testid={`solution-item-${index + 1}`}><CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-[#17835a]" /><p className="text-sm font-semibold leading-6 text-[#315f4d]">{text}</p></div>)}</div>
        </div>
      </div>
      <Link to={registrationPath} className="mt-8 inline-flex items-center gap-2 text-sm font-extrabold text-[#1947C7] hover:text-[#1337a3]" data-testid="comparison-activate-link">Inizia dalla tua prima struttura <ArrowRight className="h-4 w-4" /></Link>
    </div>
  </section>
);